import React, { Component } from 'react';
import { connect } from 'react-redux';
import Box from '@bit/knotchinc.web-react-components.box';
import Tag from 'components/Global/Tag/Tag.jsx';
import { SelectionContainer, StepContainer, Title, RadioItemTitle } from './styled.js';

class ReviewStep extends Component {
  componentDidMount() {
    this.props.setValid(true);
  }

  render() {
    const { request: { name, keywords, brands, publishers } } = this.props;

    return (
      <StepContainer>
        <Title>Review your report</Title>
        <Box mt="48px">
          <Box display="inline-block" width="30%" mr="85px" p="24px" verticalAlign="top">
            <SelectionContainer>
              {name}
            </SelectionContainer>
            <RadioItemTitle>REPORT NAME</RadioItemTitle>
          </Box>
          <Box display="inline-block" width="60%" p="24px" verticalAlign="top">
            <SelectionContainer>
              {brands.map(brand =>
                <Tag
                  type="competitor"
                  data={brand.name}
                  icon={brand.logo_url}
                />)}
            </SelectionContainer>
            <RadioItemTitle>BRANDS</RadioItemTitle>
            <SelectionContainer>
              {publishers.map(publisher =>
                <Tag
                  type="competitor"
                  data={publisher.name}
                  icon={publisher.logo_url}
                />)}
            </SelectionContainer>
            <RadioItemTitle>PUBLISHERS</RadioItemTitle>
            <SelectionContainer>
              {keywords.map(keyword =>
                <Tag
                  selected
                  type="keyword"
                  data={keyword}
                />)}
            </SelectionContainer>
            <RadioItemTitle>KEYWORDS</RadioItemTitle>
          </Box>
        </Box>
      </StepContainer>
    );
  }
}

ReviewStep.defaultProps = {
  name: 'Review Report',
};

const mapStateToProps = ({ ReportRequest: { request } }) => ({ request });

export default connect(mapStateToProps)(ReviewStep);
